import React, { useEffect } from 'react';

export type ToastType = 'success' | 'error' | 'info' | 'warning';

interface ToastProps {
  id: string;
  message: string;
  type: ToastType;
  duration?: number;
  onClose: (id: string) => void;
}

const Toast: React.FC<ToastProps> = ({ id, message, type, duration = 5000, onClose }) => {
  useEffect(() => {
    if (duration > 0) {
      const timer = setTimeout(() => onClose(id), duration);
      return () => clearTimeout(timer);
    }
  }, [id, duration, onClose]);

  const getStyles = () => {
    switch (type) {
      case 'success':
        return {
          bg: 'bg-green-500',
          icon: '✓',
          borderColor: 'border-green-600'
        };
      case 'error':
        return {
          bg: 'bg-red-500',
          icon: '✕',
          borderColor: 'border-red-600'
        };
      case 'warning':
        return {
          bg: 'bg-yellow-500',
          icon: '⚠',
          borderColor: 'border-yellow-600'
        };
      case 'info':
      default:
        return {
          bg: 'bg-blue-500',
          icon: 'ℹ',
          borderColor: 'border-blue-600'
        };
    }
  };

  const styles = getStyles();

  return (
    <div
      className={`${styles.bg} text-white px-6 py-4 rounded-lg shadow-lg flex items-center gap-3 border-l-4 ${styles.borderColor} animate-slideIn`}
      role="alert"
    >
      <span className="text-xl font-bold">{styles.icon}</span>
      <span className="flex-1">{message}</span>
      <button
        onClick={() => onClose(id)}
        className="text-white/70 hover:text-white transition"
        aria-label="Fechar notificação"
      >
        ✕
      </button>
    </div>
  );
};

export default Toast;
